const Footer = ({ component }: { component: JSX.Element }) => component;
Footer.displayName = 'Footer';

export default Footer;
